import { render } from "./PlanCambaceo.vue?vue&type=template&id=54589e2e&scoped=true&lang=pug"
import script from "./PlanCambaceo.vue?vue&type=script&lang=js"
export * from "./PlanCambaceo.vue?vue&type=script&lang=js"

import "./PlanCambaceo.vue?vue&type=style&index=0&id=54589e2e&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54589e2e"]])

export default __exports__